import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { useForm } from 'react-hook-form'
import Modal from 'react-bootstrap-modal'
import DateInputWrapper from '../open-game-form/date-input-wrapper'
import SelectInputWrapper from '../open-game-form/select-input-wrapper'
import Fields from '../open-game-form/fields'
import FlashAlert from '../flash-alert'
import { ajaxGet, patchForm } from '../../ajax'
import moment from 'moment'

function GameForm({id, onClose, onUpdate}) {
  const [payload, setPayload] = useState(null)
  const [baseField, setBaseField] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const [alert, setAlert] = useState(null)
  const [nickname, setNickname] = useState('')

  const { register, getValues, setValue, handleSubmit, formState: { errors } } = useForm()

  useEffect(() => {
    if (!payload) loadData({})
  }, [payload])

  const loadData = () => {
    setIsLoading(true)
    ajaxGet(`/admins/reservations/${id}/edit.json`)
    .then(response => { if (response.ok) return response.json() })
    .then((json) => {
      setNickname(json.nickname)
      setPayload(json)
      initForm(json.form)
      json.field_id && setBaseField(json.field_id)
      setIsLoading(false)
    })
  }
  const initForm = (data) => {
    for (const [key, value] of Object.entries(data)) { setValue(key, value) }
  }
  
  const prepareFormData = (data) => {
    let formData = new FormData()
    for (const key in data) {
      if (key == 'times') 
        data[key].forEach(v => formData.append('game[times][]', v))
      else
        formData.append(`game[${key}]`, data[key]) 
    }
    formData.append('game[field_ids][]', baseField)
    return formData
  }
  
  const onSubmit = (data) => {
    const formData = prepareFormData(data)

    patchForm(`/admins/reservations/${id}.json?`, formData)
    .then(response => { return response.json() })
    .then((json) => {
      if (json.alert)
        setAlert(json.alert)
      else
        onUpdate(json)
    })
  }

  const greaterThanFrom = (value) => {
    const from = getValues('times')[0]
    if (from >= value) return 'Must be > From'
    return true
  }

  const requiredMsg = 'Is required'
  
  if (!payload) return null

  return <Modal backdrop='static' container={document.body} show={true} onHide={onClose}>
    <Modal.Header closeButton>
      <Modal.Title>Edit Reservation</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <div className='game-form'>
        { isLoading && <div className='animated-spinner'></div> }
        { alert && <FlashAlert text={alert.text} type={alert.type} constant centred onHide={() => setAlert(null)} />}
        <form className={'form-horizontal' + (isLoading ? ' isLoading' : '')} onSubmit={handleSubmit(onSubmit)}>
          <div className='row' style={{marginTop: '8px'}}>
            <div className='col-xs-9'>
              <input className='form-control' value='Plei App Game' disabled />
              <input
                style={{marginTop: '8px'}}
                value={nickname}
                {...register('nickname')} 
                className='form-control'
                placeholder='Add a Nickname'
                onChange={e => {
                  setNickname(e.target.value)
                  setValue('nickname', e.target.value)
                }}
              />
            </div>
            <div className='col-xs-2 plei-game-category'>Plei App</div>
          </div><br />
          { !payload.has_real_players && 
            <div className='row'>
              <div className={payload.has_durations ? 'col-xs-6' : 'col-xs-9'}>
                <DateInputWrapper
                  label='Date'
                  date={moment(new Date(payload.date))}
                  disabled={true}
                />
              </div>
              { payload.has_durations &&
                <div className='col-sm-2'>
                  <SelectInputWrapper 
                    value={payload.duration}
                    label='Duration'
                    options={payload.durations}
                    disabled={true}
                    onChange={(e) => setValue('duration', e.target.value)}
                  />
                </div>
              }
              <div className='col-sm-2'>
                <SelectInputWrapper
                  {...register('times[0]', { required: requiredMsg })}
                  label='Time'
                  selectClassName='time-select'
                  options={payload.hours}
                  error={errors.times && errors.times[0]}
                  onChange={(e) => setValue('times[0]', e.target.value, { shouldValidate: true })}
                />
              </div>
              { payload.duration == 'custom' && 
                <div className='col-sm-2'>
                  <SelectInputWrapper
                    {...register('duration_end_time', { required: requiredMsg, validate: greaterThanFrom })} 
                    label='To'
                    selectClassName='time-select'
                    options={payload.hours}
                    error={errors.duration_end_time}
                    onChange={(e) => setValue('duration_end_time', e.target.value, { shouldValidate: true })}
                  />
                </div>
              }
            </div>
          }

          { payload.fields && baseField &&
            <Fields
              selected={baseField}
              fields={payload.fields} 
              fieldIndex={0}
              onChangeField={(value) => setBaseField(value)}
            /> 
          }

          <Modal.Footer>
            <input type='submit' name='commit' value='Done' className='btn btn-primary wider' />
          </Modal.Footer>
        </form>
      </div>
    </Modal.Body>
  </Modal>
}

GameForm.propTypes = {
  id: PropTypes.number,
  onClose: PropTypes.func.isRequired,
  onUpdate: PropTypes.func.isRequired
}

export default GameForm
